import React from 'react';
import {Typography, Divider, Button, TextField, Card, OutlinedInput, InputAdornment, InputLabel,
  CardContent, IconButton, Box, FormControl} from '@mui/material';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {login} from '../utils/datautils';
import { useDispatch, useSelector } from 'react-redux';
import { dataAdmin, setAdmin, setPage } from '../../storeredux';

export default function LoginContainer(){
  var admin = useSelector(dataAdmin)
  var dispatch = useDispatch()
  const [param,setParam]=React.useState({
    username:'',
    password:''
  });
  const[error,setError] = React.useState(false);
  // const[auth, setAuth] = React.useState(false);
  const[pass, setPass] = React.useState(true);

  const handlerLogin = (event) => {
    login(admin,param.username,param.password).then(path => {
      dispatch(setAdmin({name:param.username}))
      dispatch(setPage(path))
    }).catch(err => {setError(err.message)});
    setParam({username:'', password:''});
  }

  const handleChange = (event) => {
    setParam(prev => ({...prev, [event.target.name]:event.target.value}))
  }

  const handleClick = (event) => {
    setPass(!pass)
  }

  return(
    <div>
      <Box style={{width: '100vw', justifyContent:'center',alignItems:'center', display:'flex'}}>
        <Card elevation={10} style={{borderRadius:20, backgroundColor:'transparent', marginTop:'100px',maxWidth:'90vw'}}>
          {/* {
            (auth) ? (
              <Redirect to="/mpq-ums/activity-content"/>
            ):(<></>)
          } */}
          <CardContent>
            <Typography variant='h3' style={{textAlign:'center', marginBottom:'2%'
              ,fontFamily:'Lucida Sans',color:'#00e68a' ,textShadow:'2px 1px #00ff99'}}>
              <b>Login</b>
            </Typography>
            <Divider light style={{marginBottom:'50px'}}/>
            {
              (error)? (
                <Box justifyContent='center' alignItems='center' display='flex' borderRadius={10} style={{backgroundColor:'#ffb380'
                  ,marginTop:'20px'}}>
                  <Typography variant='body2' style={{color:'#ff6600',marginLeft:'5px',marginRight:'5px'}}>
                    <strong>Error :</strong><br/>
                    {error}
                  </Typography>
                </Box>
              ) : (<></>)
            }
            <Box justifyContent='center' alignItems='center' display='flex'>
              <form autoComplete='off'>
                <Box justifyContent='center' alignItems='center' display='flex'>
                  <TextField required id="username-login" name="username" label="Username" variant="outlined"
                    style={{marginTop:'20px',width:'100%'}} value={param.username} onChange={handleChange}/>
                </Box>
                <Box justifyContent='center' alignItems='center' display='flex'>
                  <FormControl variant="outlined" style={{marginTop:'20px',marginBottom:'20px',width:'100%'}}>
                    <InputLabel htmlFor='password-login'>Password *</InputLabel>
                    <OutlinedInput required id="password-login"
                      type={(pass)? 'password':'text'}
                      name="password"
                      endAdornment={
                        <InputAdornment position='end'>
                          <IconButton
                            onClick={handleClick}
                            aria-label="toggle password visibility"
                            edge='end'>
                            {(pass)? <Visibility/>:<VisibilityOff/>}
                          </IconButton>
                        </InputAdornment>
                      }
                      value={param.password}
                      labelWidth={85}
                      onChange={handleChange}/>
                  </FormControl>
                </Box>
                <Box justifyContent='center' alignItems='center' display='flex'>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handlerLogin}
                  startIcon={<DoubleArrowIcon />}
                >
                  Login
                </Button>
                </Box>
              </form>
            </Box>
            <Divider light style={{marginTop:'50px'}}/>
            <Typography gutterBottom style={{textAlign:'center',marginTop:'4%',color:'#d7d7c1'}}>
              <i>@ContentPrivacy</i>
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </div>
  )
}
